import { ListingUseType } from "~/types/listing.types";

const PROFILE_LISTING_USE_TYPE_ORDER: ListingUseType[] = [
  "Off-Site",
  "Event",
  "Production",
];

export { PROFILE_LISTING_USE_TYPE_ORDER };
